import { createContext, useContext } from 'react';
import type { EditContactApi } from '../services/api';

const EditContactApiContext = createContext<EditContactApi | null>(null);

export const EditContactApiProvider = EditContactApiContext.Provider;

export const useEditContactApi = () => {
  return useContext(EditContactApiContext);
};
